var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.975 4.25v.843c0 .038-.024.067-.06.067h-.429l.002-.007c.05-.364.23-.681.487-.903ZM7.118 1.479h7.796c.037 0 .06.027.06.065V3.59a1.995 1.995 0 0 0-1.01 1.472l-.01.047v.051H7.117c-.036 0-.074-.028-.074-.067v-3.55c0-.037 1.858-.064 1.895-.064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.209 6.743-.198.056v3.15h-1.537l.009-4.772.004-.024c.096-.702.679-1.231 1.356-1.231.755 0 1.369.645 1.369 1.437 0 .643-.415 1.212-1.003 1.384M0 5.36c0-.793.614-1.437 1.369-1.437.669 0 1.245.517 1.35 1.208l-.003.011v4.836l-1.527-.02V6.799l-.19-.056C.408 6.57 0 6.003 0 5.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 5.16c-.038 0-.074-.028-.074-.067v-.85c.256.216.438.528.493.888l-.003.011v.018h-.417ZM3.242 8.703h10.674V5.745H3.242v2.958ZM2.236 1.479H8.21c.036 0 .061.027.061.065v3.549c0 .039-.025.067-.061.067H3.188V5.1l-.003-.025a1.994 1.994 0 0 0-1.023-1.491v-2.04c0-.038.037-.065.074-.065"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.162,
    y: 0.91,
    width: 6.112,
    height: 2.275,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.526,
    y: 0.91,
    width: 9.45,
    height: 2.275,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptions);
export default __webpack_public_path__ + "static/media/receptions.edcddfb3cf7f0eacc5f54a2083b07114.svg";
export { ForwardRef as ReactComponent };